export default __webpack_public_path__ + "static/media/help9.bacf963e.png";